<template>
  <div>
    <file-input-modal
        v-if="modalUpload"
        v-model="modalUpload"
        titulo="Envie a foto da empresa"
        titulo-btn="Importar foto"
        content-type="image/png, image/jpeg"
        @selecionarArquivo="selecionarFoto"
        @modalInputFechar="fecharModalUpload"
    />
    <v-dialog
        v-model="model"
        scrollable
        @click:outside="fecharModalOutsideClick"
        :persistent="persistencia"
        :max-width="maxWidth"
        style="padding: 0">
      <v-card class="card-component">
        <v-toolbar dark color="primary" elevation="0">
          <v-toolbar-title>Adicionar parâmetro
          </v-toolbar-title>
          <v-spacer/>
          <v-btn class="close__button" text @click="fecharModal" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="color: black">
          <v-container fluid grid-list-xl white>
            <div class="container-upload-foto-empresa" @click="abrirModalUpload">
              <div class="container-upload-foto imagem-foto-empresa" v-if="!arquivoFoto">
                <v-icon size="30">add_a_photo</v-icon>
              </div>
              <v-img v-else :src="previewFoto" class="upload-nova-foto" aspect-ratio="4/3"
                     alt="Selecionar nova foto">
                <v-icon size="50">add_a_photo</v-icon>
              </v-img>
              <span>Foto empresa</span>
            </div>
            <v-row wrap align-center white>
              <v-col cols="12" md="12" sm="12" xs="12">
                <v-text-field
                    v-model="dadosGerais.nomeConfiguracao"
                    name="nomeConfiguracao"
                    placeholder="Informe o nome da configuração"
                    counter="250"
                    maxlength="250"
                    v-validate="{required: true, min: 5, max: 250}"
                    :error-messages="errors.collect('nomeConfiguracao')">
                  <template v-slot:label>
                    Nome<span class="ml-1 red--text">*</span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <div class="container-info-separacao mt-5">
              <span>Cores do sistema</span>
            </div>
            <div class="container-cores-sistema">
              <color-select
                  class="mr-5"
                  label-titulo="Cor Primária"
                  :cor-selecionada="dadosGerais.corPrimaria"
                  @atualizarCor="atualizarCorPrimaria"/>
              <color-select
                  class="mr-5"
                  label-titulo="Cor Secundária"
                  :cor-selecionada="dadosGerais.corSecundaria"
                  @atualizarCor="atualizarCorSecundaria"/>
              <color-select
                  label-titulo="Cor Terciária"
                  :cor-selecionada="dadosGerais.corTerciaria"
                  @atualizarCor="atualizarCorTerciaria"/>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="fecharModal" outlined>Cancelar</v-btn>
          <v-btn @click="inserirParametro" depressed color="primary" class="ml-5">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {actionTypes} from '@/core/constants'
import ColorSelect from '@/views/components/ColorSelect.vue'
import FileInputModal from '@/views/components/FileInputModal.vue'

export default {
    name: 'ModalAdicionarParametro',
    components: {FileInputModal, ColorSelect},
    props: {
        value: {
            type: Boolean,
            required: true
        },
        persistencia: {
            type: Boolean,
            default: false
        },
        maxWidth: {
            type: Number,
            default: 700
        }
    },
    data() {
        return {
            modalUpload: false,
            dadosGerais: {
                nomeConfiguracao: null,
                fotoEmpresa: null,
                timezone: null,
                corPrimaria: null,
                corSecundaria: null,
                corTerciaria: null
            },
            previewFoto: null,
            arquivoFoto: null,
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        fecharModal() {
            this.removerFotoUrl()
            this.model = false
            this.$emit('modalAdicionarParametroAcaoFechar')
        },
        fecharModalAposAtualizacao() {
            this.removerFotoUrl()
            this.model = false
            this.$emit('modalParametroAcaoFecharAposAtualizar')
        },
        fecharModalOutsideClick() {
            if (!this.persistencia) {
                this.fecharModal()
            }
        },
        async inserirParametro() {
            if (this.isParametroValido()) {
                this.setMensagemLoading('Criando novo parâmetro...')
                const dados = {
                    input: {
                        nomeConfiguracao: this.dadosGerais.nomeConfiguracao,
                        corPrimaria: this.dadosGerais.corPrimaria,
                        corSecundaria: this.dadosGerais.corSecundaria,
                        corTerciaria: this.dadosGerais.corTerciaria
                    },
                    fotoEmpresa: this.arquivoFoto
                }
                const resposta = await this.$store.dispatch(actionTypes.PARAMETROS.INSERIR_CONFIGURACAO, dados)
                if (resposta) {
                    this.mostrarNotificacaoSucessoDefault()
                    this.fecharModalAposAtualizacao()
                }
            }
        },
        isParametroValido() {
            if (!this.dadosGerais.nomeConfiguracao || this.dadosGerais.nomeConfiguracao.length < 5) {
                this.mostrarNotificacaoErro('O nome deve possuir no mínimo 5 caracteres!')
                return false
            }
            if (!this.dadosGerais.corPrimaria) {
                this.mostrarNotificacaoErro('Informe a cor primária!')
                return false
            }
            if (!this.dadosGerais.corSecundaria) {
                this.mostrarNotificacaoErro('Informe a cor secundária!')
                return false
            }
            if (!this.dadosGerais.corTerciaria) {
                this.mostrarNotificacaoErro('Informe a cor terciária!')
                return false
            }
            return true
        },
        atualizarCorPrimaria(novaCor) {
            this.dadosGerais.corPrimaria = novaCor
        },
        atualizarCorSecundaria(novaCor) {
            this.dadosGerais.corSecundaria = novaCor
        },
        atualizarCorTerciaria(novaCor) {
            this.dadosGerais.corTerciaria = novaCor
        },
        selecionarFoto(arquivoSelecionado) {
            if (arquivoSelecionado.type.startsWith('image/')) {
                this.previewFoto = URL.createObjectURL(arquivoSelecionado)
                this.arquivoFoto = arquivoSelecionado
            }
            this.fecharModalUpload()
        },
        abrirModalUpload() {
            this.modalUpload = true
        },
        fecharModalUpload() {
            this.modalUpload = false
        },
        removerFotoUrl() {
            if (this.arquivoFoto) {
                URL.revokeObjectURL(this.previewFoto)
                this.previewFoto = null
            }
        }
    }
}

</script>

<style scoped lang="stylus">

.container-info-separacao
  font-weight bold
  color var(--theme-primary)
  border-bottom 1px solid #ddd

.container-cores-sistema
  margin-top 10px
  display flex

.container-upload-foto-empresa
  display flex
  flex-direction column
  align-items center

  span
    font-weight bold
    color var(--theme-primary)

.container-upload-foto
  display flex
  justify-content center

.container-upload-foto:hover
  background-color #a1a1a1

.imagem-foto-empresa
  height 90px
  width 90px
  border 2px solid #eee

.imagem-foto-empresa:hover
  cursor pointer
  border 2px solid #00bcd4

.upload-nova-foto
  display flex
  align-items center
  text-align center
  height 90px
  width 90px

.upload-nova-foto >>> .v-icon
  color rgba(255, 255, 255, 0.5)

.upload-nova-foto:hover >>> .v-icon
  cursor pointer
  color white

@media (max-width 720px)
  .container-cores-sistema
    flex-direction column

</style>